import React, { useEffect, useState } from 'react';
import { AmenityModel, TagModel } from 'types/CommonTypes';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { Row } from 'saladsoft-primitive';
import { IconButton } from '@mui/material';

const AmenityItem = ({
  defaultChecked,
  amenity,
  onChange,
}: {
  defaultChecked?: boolean;
  amenity: AmenityModel;
  onChange: (amenity: AmenityModel) => void;
}) => {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  useEffect(() => {
    setIsChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <Wrapper
      isChecked={isChecked}
      onClick={() => {
        setIsChecked(!isChecked);
        onChange({ ...amenity, isChecked: !isChecked });
      }}
    >
      <Row gap={10} alignItems="center" justifyContent="space-between">
        <div>
          <div style={{ fontWeight: 600 }}>{amenity?.localizedName?.ko}</div>
        </div>
        <IconButton style={{ position: 'relative', top: -2 }}>
          {isChecked ? (
            <CloseIcon fontSize="small" style={{ color: '#30578e' }} />
          ) : (
            <AddIcon fontSize="small" />
          )}
        </IconButton>
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isChecked?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  padding-left: 20px;
  border: 1px solid #efefef;
  margin: 5px;
  border-radius: 10px;

  cursor: pointer;
  color: ${(props) => (props.isChecked ? '#30578e' : 'var(--primary-color)')};
  background-color: ${(props) => (props.isChecked ? '#dde9f6' : '#f9f9f9')};
`;

export default AmenityItem;
